import { render } from "./v-page.vue?vue&type=template&id=5a5e0c80"
import script from "./v-page.vue?vue&type=script&lang=js"
export * from "./v-page.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__